import { render } from "./TableListCard.vue?vue&type=template&id=202d3c51"
import script from "./TableListCard.vue?vue&type=script&lang=js"
export * from "./TableListCard.vue?vue&type=script&lang=js"

import "./TableListCard.vue?vue&type=style&index=0&id=202d3c51&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__